module.exports = __webpack_public_path__ + "static/22invgde-c95af3853a3e331f410e9f9342c12dd9.gif";